
import { FormExcludes } from 'apprise-frontend-core/utils/formexcludes';
import { CategoryClientCache, CategoryCloneProvider, CategoryExcludes, CategoryExcludesProvider, CustomPropertyProvider } from 'apprise-frontend-tags/category/context';
import { PropsWithChildren } from 'react';




export type CategoryProviderProps = PropsWithChildren<Partial<{

    formExcludes: FormExcludes<CategoryExcludes>

}>>

export const CategoryProvider = (props: CategoryProviderProps) => {

    const { children, formExcludes } = props

    return <CategoryClientCache>
        <CategoryCloneProvider>
            <CustomPropertyProvider>
                <CategoryExcludesProvider {...formExcludes}>
                    {children}
                </CategoryExcludesProvider>
            </CustomPropertyProvider>
        </CategoryCloneProvider>
    </CategoryClientCache>
}